var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center mr-4"},[_c('span',{staticClass:"pr-2"},[_vm._v(_vm._s(_vm.label))]),_c('custom-select',{attrs:{"options":_vm.options,"placeholder":"Page size"},model:{value:(_vm.pageSize),callback:function ($$v) {_vm.pageSize=$$v},expression:"pageSize"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }